module.exports = __webpack_public_path__ + "res/img/notask.c9a20263.png";